<div class="content-container">
  <mat-form-field appearance="outline" class="form-field">
    <mat-label>Height</mat-label>
    <input matInput type="number" autoComplete="off" (keypress)="integerOnly($event)" [ngModel]="baseDimension?.box?.height" (ngModelChange)="baseDimension.box.height = $event">
  </mat-form-field>
</div>